import { module } from 'angular';

import { default as domainFilterName, DomainFilter } from './domain-filter.component.ajs';

export default module('hypervision.skill-view.custom.filter.domain', []).component(domainFilterName, new DomainFilter()).name;
